import { defineMessages } from "react-intl";

export default defineMessages({
  unknownError: {
    id: "accounts.useErrorToast.unknownError",
    defaultMessage: "There was an error.",
  },
});
